/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsServerSlashUpLine: {
  name: 'server-slash-up-line';
  data: string;
} = {
  name: 'server-slash-up-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 3a1 1 0 0 1 1-1h12a2 2 0 0 1 2 2v11a1 1 0 1 1-2 0v-5h-6a1 1 0 1 1 0-2h6V4H7a1 1 0 0 1-1-1ZM3 14V8a1 1 0 0 1 2 0v6h6a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2Zm9 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-9 1a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H3Zm6-8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4.707 3.293a1 1 0 0 0-1.414 1.414l16 16a1 1 0 0 0 1.414-1.414l-16-16Z" fill="currentColor"/></svg>`,
};
